import { Button, Grid, Menu, Layout, Paper, Table, ButtonGroup, Loader } from "../../components";
import moment from "moment";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useAxios } from '../../hooks'
import { useContext } from "react";
import AuthContext from "../../context/auth";
import { Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { formatCPF } from "../../utils";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import TelegramIcon from '@mui/icons-material/Telegram';

export function Users () {
    const navigate = useNavigate()
    const { me } = useContext(AuthContext)

    const [users, refetchUsers] = useAxios(`/user`)
    const [status, updateUserStatus] = useAxios({
        method: 'PUT'
    }, {
        manual: true
    })
    
    return (
        <Layout>
            <Grid container justifyContent="center" minHeight={"calc(100vh - 64px)"} padding={3} >
                {users.loading || status.loading ? (
                    <div style={{
                        display: 'flex',
                        flex: '1',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <Loader />
                    </div>
                ) : ( <Grid item xs={12} sm={10}>
                    <Paper elevation={1}>
                    <Table 
                        columns={[
                            { field: 'id', headerName: 'ID', width: 50 },
                            { field: 'created_at', headerName: 'Data', flex: 1, valueFormatter: ({value}) => {
                                return moment(value).format('DD/MM/YYYY HH:mm:ss')
                            } },
                            { field: 'name', headerName: 'Nome', flex: 2 },
                            { field: 'email', headerName: 'E-mail', flex: 1 },
                            { field: 'cpf', headerName: 'CPF', flex: 1, valueFormatter: ({value}) => formatCPF(value) },
                            { field: 'active', headerName: 'Status', flex: 1, valueFormatter: ({value}) => value ? 'Ativo' : 'Inativo', renderCell: ({value, formattedValue}) =>  (
                                <Chip color={value ? 'success' : 'error'} label={formattedValue} />
                            ) },
                            {
                                field: 'actions', headerName: '', align: 'right', sortable: false, filterable: false, disableColumnMenu: true, flex: 1, renderCell: ({row}) => {
                                    const messageText = encodeURI(`Olá, ${row.name}! Tudo bem? Sou ${me?.name}, da Next Pontos.`)

                                    const menuOptions = [
                                        { label: 'Detalhes', onClick: () => { navigate(`/usuarios/${row.id}`) }}
                                    ]

                                    if (row.active) {
                                        menuOptions.push({
                                            label: 'Desativar', 
                                            onClick: async () => {
                                                await updateUserStatus({
                                                    url: `/user/${row.id}/status`,
                                                    data: {
                                                        active: false
                                                    }
                                                }) 

                                                refetchUsers()
                                        }})
                                    } else {
                                        menuOptions.push({
                                            label: 'Ativar', 
                                            onClick: async () => { 
                                                await updateUserStatus({
                                                    url: `/user/${row.id}/status`,
                                                    data: {
                                                        active: true
                                                    }
                                                }) 

                                                refetchUsers()
                                        }})
                                    }
                                    
                                    return (
                                        <ButtonGroup>
                                            <Button 
                                                variant="outlined"
                                                onClick={() => 
                                                    window.open(`https://api.whatsapp.com/send?phone=${row.whatsapp}&text=${messageText}`, '_blank')
                                                }
                                            >
                                                <WhatsAppIcon />
                                            </Button>
                                            <Button 
                                                variant="outlined"
                                                onClick={() => 
                                                    window.open(`https://t.me/${row.telegram.replace('@', '')}?text=${messageText}`, '_blank')
                                                }
                                            >
                                                <TelegramIcon />
                                            </Button>
                                            <Menu
                                                options={menuOptions}
                                            >
                                                <MoreHorizIcon />
                                            </Menu>
                                        </ButtonGroup>
                                    )
                                }
                            }
                        ]}
                        rows={(users?.data || [])}
                    />
                    </Paper>
                </Grid>)}
            </Grid>
        </Layout>
    )
}